import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

import {OnboardingOption} from '../../onboarding-option';

import styles from '../../onboarding-body.module.css';

export function OnboardingBodyOtherSteps() {
    return (
        <OnboardingBody title='We also:'>
            <div>
                <div className={styles['check-all']}>
                    <em>(check all that apply)</em>
                </div>
                <OnboardingOption
                    option='usesProposalDocumentStep'
                    label='Prepare a proposal or estimate before the sale'
                />
                <OnboardingOption
                    option='usesFollowupStep'
                    label='Plan for a follow-up sale after winning a lead'
                />
                <OnboardingOption option='usesNoOtherStep' label='None of the above' />
            </div>
        </OnboardingBody>
    );
}
